module.exports = __webpack_public_path__ + "static/media/staff-2.aab67bac.jpg";